import { Button, HStack, Input, Select, VStack } from '@chakra-ui/react';
import { useState } from 'react';
import { AsyncSelect } from 'chakra-react-select';
import { fetcher } from '@olagg/api-hooks';
import { AdminSegmentEndpoints, AdminUserEndpoints } from '@olagg/api-hooks/endpoints/adminEndpoints';

interface PushNotificationsFilterProps {
  onFilter: (filters: FilterParams) => void;
}

export interface FilterParams {
  title?: string;
  status?: string;
  segment_id?: number;
  user_id?: number;
  from_date?: string;
  to_date?: string;
}

export const PushNotificationsFilter = ({ onFilter }: PushNotificationsFilterProps) => {
  const [title, setTitle] = useState('');
  const [status, setStatus] = useState('');
  const [selectedSegment, setSelectedSegment] = useState<any>(null);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const handleSearchSegments = async (inputValue: string) => {
    return await fetcher(
      AdminSegmentEndpoints.all({ page: 1, limit: 10, name: inputValue })
    ).then((response) => {
      const { segments } = response;
      return segments.map((segment: any) => ({
        value: segment.id,
        label: segment.name
      }));
    });
  };

  const handleSearchUsers = async (inputValue: string) => {
    return await fetcher(
      AdminUserEndpoints.all({ page: 1, limit: 10, query: inputValue })
    ).then((response) => {
      const { users } = response;
      return users.map((user: any) => ({
        value: user.id,
        label: `${user.name} (${user.email})`
      }));
    });
  };

  const handleFilter = () => {
    onFilter({
      title: title || undefined,
      status: status || undefined,
      segment_id: selectedSegment?.value || undefined,
      user_id: selectedUser?.value || undefined,
      from_date: fromDate || undefined,
      to_date: toDate || undefined,
    });
  };

  const handleClear = () => {
    setTitle('');
    setStatus('');
    setSelectedSegment(null);
    setSelectedUser(null);
    setFromDate('');
    setToDate('');
    onFilter({});
  };

  return (
    <VStack w={'full'} spacing={4} bg={'gray.800'} p={4} borderRadius={'md'}>
      <HStack w={'full'} spacing={4}>
        <Input
          placeholder="Buscar por título..."
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          bg={'gray.700'}
          color={'white'}
        />
        <Select
          placeholder="Todos los estados"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          bg={'gray.700'}
          color={'white'}
        >
          <option value="draft">Draft</option>
          <option value="scheduled">Programada</option>
          <option value="sending">Enviando</option>
          <option value="sent">Enviada</option>
          <option value="failed">Fallida</option>
        </Select>
      </HStack>

      <HStack w={'full'} spacing={4}>
        <AsyncSelect
          value={selectedSegment}
          onChange={setSelectedSegment}
          loadOptions={handleSearchSegments}
          placeholder="Buscar segmento..."
          isClearable
          chakraStyles={{
            container: (provided) => ({ ...provided, bg: 'gray.700', flex: 1 }),
            menuList: (provided) => ({ ...provided, bg: 'gray.700' }),
            option: (provided, { isFocused }) => ({
              ...provided,
              bg: isFocused ? 'gray.600' : 'gray.700',
            }),
          }}
        />
        <AsyncSelect
          value={selectedUser}
          onChange={setSelectedUser}
          loadOptions={handleSearchUsers}
          placeholder="Buscar usuario..."
          isClearable
          chakraStyles={{
            container: (provided) => ({ ...provided, bg: 'gray.700', flex: 1 }),
            menuList: (provided) => ({ ...provided, bg: 'gray.700' }),
            option: (provided, { isFocused }) => ({
              ...provided,
              bg: isFocused ? 'gray.600' : 'gray.700',
            }),
          }}
        />
      </HStack>

      <HStack w={'full'} spacing={4}>
        <Input
          placeholder="Desde"
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          bg={'gray.700'}
          color={'white'}
        />
        <Input
          placeholder="Hasta"
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          bg={'gray.700'}
          color={'white'}
        />
      </HStack>

      <HStack w={'full'} spacing={4} justifyContent={'flex-end'}>
        <Button onClick={handleClear} variant={'outline'} colorScheme={'gray'}>
          Limpiar
        </Button>
        <Button onClick={handleFilter} colorScheme={'purple'}>
          Filtrar
        </Button>
      </HStack>
    </VStack>
  );
};
